import { Chip, Tooltip } from '@mui/material'

import { useT } from '@clara/locale'
import { ReimbursementStatus } from '@/features/reimbursements/types/reimbursement'

const ColorMap: Record<
  ReimbursementStatus,
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning'
  | 'advice'
  | 'neutral'
> = {
  PENDING: 'warning',
  APPROVED: 'info',
  REJECTED: 'error',
  SENT_TO_PAY: 'advice',
  PAID: 'success',
  DRAFT: 'warning',
  FINANCE_REJECTED: 'error',
  // TODO: not being used
  PROGRESS: 'error',
  CANCELLED: 'error',
  NOT_FOUND: 'error',
  UNAUTHORIZED: 'error',
  PAYMENT_IN_PROGRESS: 'advice',
}

type PaymentMethod = 'NOT_CLARA' | 'DEBIT' | 'CREDIT'

const resolveStatusDescription = (
  status: ReimbursementStatus,
  paymentMethod: PaymentMethod,
) => {
  if (paymentMethod === 'NOT_CLARA') {
    return `statusDescription.markedAsPaid`
  }
  return `statusDescription.${status}`
}

const ReimbursementStatusChip = ({
  status: statusProp,
  paymentMethod,
}: {
  status: ReimbursementStatus
  paymentMethod: PaymentMethod
}) => {
  const { t } = useT('reimbursements')
  const status = statusProp === 'FINANCE_REJECTED' ? 'REJECTED' : statusProp
  return (
    <Tooltip
      title={t(resolveStatusDescription(status, paymentMethod))}
      placement="top"
    >
      <Chip
        label={t(`statuses.${status}`)}
        color={ColorMap[status] as any}
        size="small"
      />
    </Tooltip>
  )
}

export default ReimbursementStatusChip
